module.exports = __webpack_public_path__ + "static/media/CheckedCircleIncorrect.9ccecfbc.svg";